<!--
  name : 김혜진
  desc : 사용자 메일 인증
  date : 2020-12-08
-->
<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" class="login_main_title">사용자 메일 인증</v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center">
      <v-card
        id="popStyle02"
        class="popW800"
        v-if="this.isCheckAuth === 'loading'"
      >
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            글로싸인엔터프라이즈 회원 가입 이메일 인증 화면 입니다.
          </div>
          <div class="popCon_txt">
            <span class="txtst_info_gray"
              >메일인증이 진행 중입니다. 잠시만 기다려 주세요.</span
            >
          </div>
        </v-card-text>
      </v-card>
      <v-card
        id="popStyle02"
        class="popW800"
        v-else-if="this.isCheckAuth === 'done'"
      >
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            글로싸인엔터프라이즈 인증을 완료하였습니다.<br />기존 회원가입 진행
            화면에서 계속 진행하여 주세요.
          </div>
          <div class="popCon_txt">
            <span class="txtst_info_gray"
              >본 페이지의 인증완료 후 기존의 가입페이지의 [인증완료] 버튼을
              클릭하면 회원가입을 계속 진행할 수 있습니다.</span
            >
          </div>
        </v-card-text>
      </v-card>
      <v-card id="popStyle02" class="popW800" v-else>
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            메일 인증실패<br />다시 시도해주세요 (메일함의 링크를 다시
            선택하거나, 다시 인증을 신청하세요)
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>s
  </v-container>
</template>
<script>
import { confirmAuthmail, isCheckAuthKey } from "@/api/join";

export default {
  name: "",
  components: {},
  filters: {},
  data() {
    return {
      isCheckAuth: "",
      confirmUserInfo: {
        userid: "",
        auth_key: "",
        email: ""
      }
    };
  },
  created() {
    this.isCheckAuth = "loading";
    this.mounted();
  },
  methods: {
    mounted() {
      // console.log('mounted-confirmPage')
      this.confirmUserInfo.email = this.$route.query.email;
      this.confirmUserInfo.user_id = this.$route.query.user_id;
      this.confirmUserInfo.auth_key = this.$route.query.auth_key;
      this.$nextTick(() => {
        this.Check_authKey();
      });
    },
    Check_authKey() {
      this.$refs.loading.start("인증 확인 중");
      confirmAuthmail(
        JSON.stringify({
          auth_key: this.confirmUserInfo.auth_key,
          email: this.confirmUserInfo.email
        })
      ).then(Response => {
        if (Response.rdata.rcode === 20000) {
          this.$refs.loading.end();
          this.update_UserAuthInfo();
        } else {
          this.$refs.loading.end();
          this.isCheckAuth = "error";
          this.$refs.confirm.open(
            "alert",
            "이메일인증",
            Response.rdata.message
          );
        }
      });
    },
    update_UserAuthInfo() {
      // console.log('update_UserAuthInfo-confirmPage')
      this.$refs.loading.start("인증 확인 중");
      isCheckAuthKey(
        JSON.stringify({ auth_key: this.confirmUserInfo.auth_key })
      ).then(Response => {
        if (Response.rdata.rcode === 20000) {
          this.$refs.loading.end();
          this.isCheckAuth = "done";
        } else {
          this.$refs.loading.end();
          this.isCheckAuth = "error";
          this.cancelAlert(Response.rdata.message);
        }
      });
    }
  }
};
</script>
<style scoped></style>
